import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  GetSavedPerformanceReportList
} from "../../Repository/Api";
import { FinancialYearView, MonthView } from "../Common/FinancialYear";
import { errorMsg } from "../Toastify";

const StaffScoreReport = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();

  const [savedReport, setSavedReport] = useState({});

  useEffect(() => {
    getSavedReport();
  }, []);

  const getSavedReport = async () => {
    const response = await GetSavedPerformanceReportList(token);
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data?.report);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Staff/StaffScoreReportApply");
                    }}
                  >
                    Apply Performance Report
                  </button>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Staff/StaffScoreReportGenerate");
                    }}
                  >
                    Generate Overall Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">Perfomance Report Status</h6>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Year</th>
                      <th scope="col">Month</th>
                      <th scope="col">Application</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedReport?.length > 0 ? (
                      savedReport &&
                      savedReport?.map((saved, index) => (
                        <tr key={index}>
                          <td>
                            {saved?.academic_year ? FinancialYearView(saved?.month, saved?.academic_year) : "-"}
                          </td>
                          <td>{saved?.month ? MonthView(saved?.month) : "-"}</td>
                          <td className="viewoption">
                            <Link
                              to={`/app/Staff/StaffScoreReportSpecificview/${saved?.id}`}
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffScoreReport;
